import React, { useEffect, useState } from 'react';
import { Button, Empty, List, Popconfirm } from 'antd';
import IconMarkerOff from '../../assets/icons/marker_off.svg';
import IconMarker from '../../assets/icons/marker.svg';
import IconDelete from '../../assets/icons/delete.svg';
import Spinner from '../../components/Spinner';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const MarkLocationComponent = ({ data, onCreate, onRemove, onView }) => {
  const { t } = useTranslation();
  const [markers, setMarkers] = useState(data);
  useEffect(() => {
    if (data) {
      setMarkers(data);
    }
  }, [data]);
  return (
    <div
      className={classNames('left-tab-component', {
        have_child: markers && markers.length > 0,
      })}
    >
      {markers ? (
        markers.length > 0 ? (
          <List
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item) => (
              <List.Item>
                <div className="child-marker-component">
                  <div className="marker-icon">
                    <img src={IconMarker} alt="marker" />
                  </div>
                  <div
                    onClick={() => onView(item.lat, item.lng)}
                    className="info"
                  >
                    <div className="name" title={item.name}>
                      {item.name}
                    </div>
                  </div>
                  <div className="remove-btn">
                    <Popconfirm
                      placement="leftTop"
                      title={t('Are you sure？')}
                      okText={t('Yes')}
                      onConfirm={() => onRemove(item.key)}
                      cancelText={t('No')}
                    >
                      <img src={IconDelete} alt="delete" />
                    </Popconfirm>
                  </div>
                </div>
              </List.Item>
            )}
          />
        ) : (
          <div className="empty-video">
            <Empty
              image={IconMarkerOff}
              imageStyle={{
                height: 80,
              }}
              description={<span>{t('No location for quick access!')}</span>}
            >
              <Button onClick={() => onCreate()} type="primary">
                {t('Create Now')}
              </Button>
            </Empty>
          </div>
        )
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default MarkLocationComponent;
